"use client";

// Reps : les quêtes du jour dans le rail droit (façon Duolingo). Réutilise le
// QuestList du dashboard tel quel : mêmes quêtes (progression partagée entre
// les surfaces), réclamation et coffres inclus. Seul l'habillage change, pour
// s'aligner sur les autres cartes du rail. Le wrapper existe aussi parce que
// QuestList n'a pas de directive "use client" : importé depuis RepsRail
// (composant serveur), il doit passer par une frontière client.
import QuestList from "@/components/Quests/QuestList";

export default function RepsQuestsCard() {
    return (
        <QuestList
            cardClass="rounded-xl border border-gray-100 bg-white p-4 dark:border-borderDark dark:bg-bgDark-840"
            titleFontSize="text-sm"
        />
    );
}
